import {Model} from 'vue-mc';

export class SucursalModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      clave : null
      , name: ""
      , email: ""
      , tipoArchivo: null
      , status: true
      , locationAddress:""
      , locationCity:""
      , locationRegionCode:""
      , locationCountryCode:""
      , locationPostalCode:""
      , consecutivoArchivosGenerados:0
      , numeroComercio : null
      , summitterId : null
      , comercio: null
      , nombreArchivoCartRefresh: ""
      , nombreArchivoCartRefreshCarga: ""
      , mcc: ''
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      clave:clave=>clave
      , name:name=>name
      , email:email=>email
      , tipoArchivo:tipoArchivo=>tipoArchivo
      , status:status=>status
      , locationAddress: locationAddress => locationAddress
      , locationCity: locationCity => locationCity
      , locationRegionCode: locationRegionCode => locationRegionCode
      , locationCountryCode: locationCountryCode => locationCountryCode
      , locationPostalCode: locationPostalCode => locationPostalCode
      , consecutivoArchivosGenerados: consecutivoArchivosGenerados => consecutivoArchivosGenerados
      , numeroComercio:  numeroComercio =>  numeroComercio
      , summitterId: summitterId => summitterId
      , comercio: comercio => comercio
      , nombreArchivoCartRefresh: nombreArchivoCartRefresh => nombreArchivoCartRefresh
      , mcc: mcc => mcc
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}



// WEBPACK FOOTER //
// ./src/models/generales/sucursal.js